import React, { Component } from 'react';
import {Link, withRouter} from 'react-router-dom';

const linkClass = 'd-flex justify-content-center align-items-center w-100 h-100';

const navItems = [
  {key: 'savedproperties', label: 'Saved Properties', oldKey: 'favourites'},
  {key: 'trackedsuburbs', label: 'Tracked Suburbs', oldKey: 'trackedsuburbs'},
  {key: 'trackedproperties', label: 'Tracked Properties', oldKey: 'trackedproperties'},
  {key: 'searches', label: 'Saved Search Alerts', oldKey: 'searches'},
  {key: 'claimedproperties', label: 'My Properties', oldKey: 'claimedproperties'},
];

class Nav extends Component {
  mobileNav = (evt) => {
    this.props.history.push('/members/' + evt.target.value);
  };

  render() {
    return (
      <React.Fragment>
        <div className="d-none d-sm-flex pillTabs pillWide">
          {navItems.map((item, index) => <div key={index} className={(this.props.current == item.key || this.props.current == item.oldKey) ? 'pillActive' : ''}><Link className={linkClass} to={'/members/' + item.key}>{item.label}</Link></div>)}
        </div>
        <div className="d-block d-sm-none form-group">
          <label htmlFor="mobileNav" className="smText">Jump to section:</label>
          <select id="mobileNav" className="form-control w-100" value={this.props.current} onChange={this.mobileNav}>
            {navItems.map((item, index) => <option key={index} value={item.key}>{item.label}</option>)}
          </select>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(Nav);
